(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ln-chat-script"] && !Shopify.designMode) return;
  try {
    function lnChatNormalize(value) {
  return typeof value === 'string' ? value.slice(0, 600).normalize('NFKD').replace(/[\u0300-\u036f\u200B-\u200D\uFEFF]/g, '').toLowerCase().replace(/ß/g, 'ss') : '';
}

function lnChatSensitive(value) {
  const text = lnChatNormalize(value);
  return /[^\s@]+@[^\s@]+\.[^\s@]+|\d[\d\s()+-]{4,}\d|#\s*\d{3,}|(?:bestell(?:ung|nummer)|order(?: number)?)[^\d]{0,15}\d{3,}|passwort|password|anmeldecode|einmalcode|meine adresse|my address|mein code/.test(text);
}

function lnChatClassify(value, previous) {
  const text = lnChatNormalize(value).trim();
  if (!text) return 'fallback';
  const compact = text.replace(/[^a-z]/g, '');
  const floor = /paddock|platte|matsch|boden|drainage|trittschicht|unterbau|verleg|muddy|floor|tile/.test(text);
  const health = /mauke|strahlf(?:a|ae)ule|sommerekzem|dermatitis|thrush|mudfever/.test(compact) || /krank|heil|therap|entzund|entzuend|antibakter|desinfiz|pilz|infektion|antibiotik|vorbeug|prevent|cure|treat|infection|eczema|allerg|trachtig|traechtig|pregnan/.test(text);
  const urgent = /lahm|blut|schmerz|wunde|wundstelle|offen(?:e|en|er)?\s+(?:haut|stell)|nassend|naessend|eiter|fieber|kolik|atemnot|bleed|wound|lame|\bpain\b|open\s+(?:skin|sore)|weeping|skin lesion|fever|colic/.test(text);
  const shipment = /bestell|liefer|sendung|versand|tracking|paket|order|shipment|delivery|parcel|package/.test(text);
  const otherShop = /horses[\s'-]*home|paddock|platten|\binb\b/.test(text);
  if (urgent) return 'urgent';
  if (health) return floor ? 'health_floor' : 'health';
  if (shipment && otherShop) return 'other_shop';
  if (/datenschutz|gespeichert|speicherst|privacy|personal data|passwort|password|anmeldecode|einmalcode|login code/.test(text)) return 'privacy';
  if (/retour|widerruf|erstatt|reklam|storn|return|refund|cancel/.test(text)) return 'returns';
  if (/human use|fur menschen|fuer menschen/.test(text)) return 'other_animal';
  if (/kontakt|mitarbeiter|support|mensch|team|\bhuman\b/.test(text)) return 'contact';
  if (/versandkosten|lieferzeit|shipping cost|delivery time|express|wie lange.*liefer|how long.*deliver/.test(text) || (/versand|shipping/.test(text) && /kost|preis|cost|price/.test(text))) return 'shipping';
  if (/welches? set|which set|wie viele flaschen|how many bottles|wo.*(?:kaufen|bestellen)|where.*(?:buy|order)|(?:mochte|moechte|will|can i|want to).*bestellen|(?:can i|want to).*order/.test(text) && !/meine? bestellung|my order|bestellstatus|order status/.test(text)) return 'sets';
  if (shipment) return 'tracking';
  if (/zertifikat|zertifizierung|certificate|fibl|dermatest|siegel/.test(text)) return 'certificates';
  if (/download|\bpdf\b|herunterlad|speichern|dokument|document|print|drucken/.test(text)) return 'downloads';
  if (/inhaltsstoff|zusammensetzung|rezeptur|ingredient|was.*drin|enthalt|enthaelt|composition/.test(text)) return 'ingredients';
  if (/bio|organic|gvo|gmo|pflanzenol|pflanzenoel|plant oil|\bole\b|\boele\b/.test(text)) return 'organic';
  if (/konservier|duftstoff|farbstoff|mineralol|mineralöl|parfum|preservative|fragrance|colourant|colorant|free from|ohne.*duft/.test(text)) return 'free_from';
  if (/herkunft|hergestellt|herstellung|made in|manufactur|origin/.test(text)) return 'origin';
  if (/ph.wert|ph.neutral|\bph\b/.test(text)) return 'ph';
  if (/alkohol|alcohol|ethanol/.test(text)) return 'alcohol';
  if (/salz|salt|natrium|chlorid/.test(text)) return 'salt';
  if (/funktion|wie.*\bwirk|reinigungsprinzip|how.*work|mechanism/.test(text)) return 'mechanism';
  if (/seife|soap/.test(text)) return 'ingredients';
  if (/haltbar|ablaufdatum|verfall|nach.*offnen|nach.*oeffnen|shelf|expir|after opening/.test(text)) return 'shelf';
  if (/lager|aufbewahr|sonnenlicht|temperatur|storage|store it|sunlight/.test(text)) return 'storage';
  if (/hund|katze|hunde|katzen|\bdog\b|\bcat\b|human use|fur menschen|fuer menschen|other animal/.test(text)) return 'other_animal';
  if (/huf|hufe|hoof|bandag|verband|verbande/.test(text)) return 'hoof';
  if (/verdunn|verduenn|misch|dilut|mixing|mix with/.test(text)) return 'dilution';
  if (/preis|kost|\bsets?\b|kaufen|price|buy|shop|spruhkopf|spruehkopf|spray head|flaschen|bottles|vorrat/.test(text)) return 'sets';
  if (/haufig|haeufig|wie oft|wie viel|wieviel|dosier|taglich|taeglich|menge|frequency|how often|how much|dosage/.test(text)) return 'frequency';
  if (/abspul|abspuel|abwasch|auswasch|rinse|wash off|drauflassen|leave on|leave it on/.test(text)) return 'rinse';
  if (/einwirk|wie lange|minuten|contact time|how long|minutes/.test(text)) return /storage|shelf/.test(previous || '') ? 'shelf' : 'duration';
  if (/anwend|wende.*an|benutz|spray|wasch|auftragen|einmassier|application|apply|wash lotion|use it|how.*use/.test(text)) return 'application';
  if (floor) return 'paddock';
  if (/horses[\s'-]*home|\binb\b/.test(text)) return 'horses_home';
  if (/wer bist|wie heisst|dein name|was kannst du|who are|your name|what can you do|bist du.*(?:echt|ki)|are you.*(?:real|ai)/.test(text) || text === 'luna') return 'identity';
  if (/^(danke|vielen dank|thanks|thank you|dankeschon|dankeschoen)[!. ]*$/.test(text)) return 'thanks';
  if (/^(hallo|hi|hey|guten tag|hello)[!. ]*$/.test(text)) return 'welcome';
  if (/^(und danach|was dann|what next|and then)[?!. ]*$/.test(text) && /application|duration|dilution|frequency/.test(previous || '')) return 'rinse';
  if (/lunara|pflege|haut|fell|care|skin|coat|produkt/.test(text)) return 'overview';
  return 'fallback';
}

document.querySelectorAll('[data-ln-chat]').forEach(function (root) {
  if (root.dataset.ready === 'true') return;
  const launcher = root.querySelector('[data-chat-launcher]');
  const dialog = root.querySelector('dialog');
  const log = root.querySelector('[data-chat-log]');
  const input = root.querySelector('[data-chat-input]');
  const form = root.querySelector('form');
  if (!launcher || !dialog || typeof dialog.showModal !== 'function' || !log || !input || !form) return;
  root.dataset.ready = 'true';
  const templates = new Map(Array.from(root.querySelectorAll('template[data-answer]'), node => [node.dataset.answer, node]));

  let previous = '';
  function appendAnswer(key) {
    const template = templates.get(key) || templates.get('fallback');
    if (!template) return;
    const entry = document.createElement('div');
    entry.className = 'ln-chat__message ln-chat__message--assistant';
    entry.dataset.answerKey = key;
    previous = key;
    entry.append(template.content.cloneNode(true));
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview && /^\d+$/.test(preview)) entry.querySelectorAll('a[href]').forEach(anchor => {
      const url = new URL(anchor.href, location.origin);
      if (url.origin === location.origin && /^(?:\/en)?\/(?:pages|products)(?:\/|$)/.test(url.pathname)) {
        url.searchParams.set('preview_theme_id', preview);
        anchor.href = url.href;
      }
    });
    log.append(entry);
    while (log.children.length > 40) log.firstElementChild.remove();
    requestAnimationFrame(function () { log.scrollTop += entry.getBoundingClientRect().top - log.getBoundingClientRect().top - 12; });
  }

  function ask(text, key) {
    const clean = typeof text === 'string' ? text.trim().slice(0, 600) : '';
    if (!clean) return;
    const entry = document.createElement('p');
    entry.className = 'ln-chat__message ln-chat__message--user';
    entry.textContent = lnChatSensitive(clean) ? root.dataset.privateLabel : clean;
    log.append(entry);
    appendAnswer(key || lnChatClassify(clean, previous));
    input.value = '';
  }

  function reset() {
    log.replaceChildren();
    input.value = '';
    appendAnswer('welcome');
  }

  launcher.hidden = false;
  launcher.addEventListener('click', function () {
    if (dialog.open) return;
    if (!log.children.length) reset();
    dialog.showModal();
    launcher.setAttribute('aria-expanded', 'true');
    root.querySelector('[data-chat-close]').focus();
  });
  root.querySelector('[data-chat-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', function () {
    launcher.setAttribute('aria-expanded', 'false');
    launcher.focus();
  });
  dialog.addEventListener('click', function (event) {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
  });
  root.querySelector('[data-chat-reset]').addEventListener('click', function () {
    reset();
    input.focus();
  });
  root.addEventListener('click', function (event) { const button = event.target.closest('[data-chat-topic]'); if (button && root.contains(button)) ask(button.textContent, button.dataset.chatTopic); });
  form.addEventListener('submit', function (event) {
    event.preventDefault();
    ask(input.value);
    input.focus();
  });
});
  } catch(e) { console.error(e); }
})();

})();
